import api from '@/js/services/api';

export default {

    addNewTag(name) {
        return api().post(`/master-admin/tags/add`, {name})
    },

    getTagsList(filters) {
        const searchParams = new URLSearchParams();

        for (const [key, value] of Object.entries(filters)) {
            searchParams.append(key, value)
        }

        return api().get('/master-admin/tags/get?' + searchParams.toString())
    },

    delete(id) {
        return api().delete(`/master-admin/tags/` + id + `/delete`);
    },

    updateTag(id, name) {
        return api().put(`/master-admin/tags/${id}/update`, {name})
    }

}
